import { SelectChangeEvent, Stack } from "@mui/material"
import { Dropdown, EPopupTriggerType, TextField, TPopupTrigger, Typography } from "@cakemail-org/ui-components-v2"
import { useTranslation } from "react-i18next"
import "./styles.scss"
import { ChangeEvent, useState } from "react"
import { TTextField } from "@cakemail-org/ui-components-v2/dist/esm/components/textField/types"

//For lack of time, we will use a simple popup sample query
// Until we build full fledge query builder

export type TPopupSampleQueryCondition = {
    onValueChange: ({ name, value }: { name: keyof TPopupTrigger, value: any }) => void,
    defaultValue: any,
    condition: EPopupTriggerType,
    onConditionChange: (condition: EPopupTriggerType) => void
}

export function PopupSampleQueryCondition({ onValueChange, defaultValue, condition, onConditionChange }: TPopupSampleQueryCondition) {
    const { t } = useTranslation()
    const [valueState, setValueState] = useState(defaultValue)

    function handleChange(event: SelectChangeEvent<string>) {
        onConditionChange && onConditionChange(event.target.value as EPopupTriggerType)
    }

    function handleChangeValue(event: ChangeEvent<HTMLInputElement>) {
        setValueState(event.target.value)
    }

    function handleChangeValueTimeout(event: ChangeEvent<HTMLInputElement>) {
        onValueChange && onValueChange({ name: event.target.name as keyof TPopupTrigger, value: event.target.value })
    }

    let conditionComponent = <></>

    if ([EPopupTriggerType.on_time_delay, EPopupTriggerType.on_click, EPopupTriggerType.on_scroll].includes(condition)) {

        const commonProps: Partial<TTextField> = {
            value: valueState,
            variant: "standard",
            onChange: handleChangeValue,
            timeout: {
                callback: handleChangeValueTimeout
            }
        }
        let inputComponent = <TextField
            key="delay_seconds"
            name="delay_seconds"
            type="number"
            inputProps={{
                min: 0,
                max: 60 * 60 //1 hour
            }}
            {...commonProps}
        />
        let operatorString: string | null = "query-builder-operator-more-than"
        let endValueString: string | null = "general-second-txt_other"

        if (condition === EPopupTriggerType.on_scroll) {
            endValueString = "general-percent"
            inputComponent = <TextField
                key="scroll_percentage"
                name="scroll_percentage"
                type="number"
                inputProps={{
                    min: 0,
                    max: 100
                }}
                {...commonProps}
            />
        } else if (condition === EPopupTriggerType.on_click) {
            operatorString = null
            endValueString = null
            inputComponent = <TextField
                key="selector"
                name="selector"
                placeholder={t("query-builder-value-selector-placeholder")}
                {...commonProps}
            />
        }

        conditionComponent =
            <Stack className="popupSampleConditionValue" direction="row" justifyContent="space-between" alignItems="center">
                {operatorString && <Typography variant="body1" color="primary.main" className="semiBold">{t(operatorString)}</Typography>}
                {inputComponent}
                {endValueString && <Typography variant="body1" color="primary.main" className="semiBold">{t(endValueString)}</Typography>}
            </Stack>
    }

    const triggerOptions = Object.values(EPopupTriggerType).map((trigger) => {
        return {
            text: t(`query-builder-popup-trigger-${trigger}`),
            value: trigger
        }
    })

    return <Stack className="popupSampleCondition">
        <Stack className="popupSampleConditionHead" justifyContent="flex-start" alignItems="center">
            <Dropdown
                placeholder={t("query-builder-trigger-condition-placeholder")}
                color="body1"
                variant="filled"
                options={triggerOptions}
                value={condition}
                onChange={handleChange}
            />
            {conditionComponent}
        </Stack>
    </Stack>
}